import React, { Component } from 'react';
import IndividualFaq from './IndividualFaq';

class FAQS extends Component {
    render() {
        const { faqs } = this.props;
        return (
            <div className="faq-list">
                {faqs.map(faq => {
                    return (
                        <IndividualFaq
                            faq={faq}
                            key={`faq-${faq.id}`}
                        />
                    );
                })}
            </div>
        );
    }
}

export default FAQS;
